// extracted by mini-css-extract-plugin
export default {"root":"styles_root__foIgH","container":"styles_container__Fkh9M","text":"styles_text__+hrQW","tip":"styles_tip__xij7U","image":"styles_image__tNHMc"};